module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-02-jp.3f3b22a18683e5322ddf906c57910c8c.png";